import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { SERVICE_URLS, ITCIApplicationPublishRequest, ITCIApplicationPublishResponse, TCI_APP_DEPLOYMENT_STAGE } from "@tci/common";
import { Observable, Subject } from "rxjs";

export interface ITCIMarkAliveState {
    appId: string;
    stage: TCI_APP_DEPLOYMENT_STAGE;
}

@Injectable()
export class BaseAppHMMarkLiveService {
    private static instance: BaseAppHMMarkLiveService = null;

    private status$: Subject<ITCIMarkAliveState> = new Subject();

    public static getInstance(http: Http) {
        if (!BaseAppHMMarkLiveService.instance) {
            BaseAppHMMarkLiveService.instance = new BaseAppHMMarkLiveService(http);
        }
        return BaseAppHMMarkLiveService.instance;
    }

    constructor(private http: Http) { }

    public updateMarkAlive(appReq: ITCIApplicationPublishRequest): Observable<ITCIApplicationPublishResponse> {
        return this.http.post(`${SERVICE_URLS.PUBLISH}/${appReq.appId}`, appReq)
            .map((response: Response) => response.json());
    }

    public publishStatus(appId: string, state: TCI_APP_DEPLOYMENT_STAGE) {
        this.status$.next({ appId, stage: state });
    }

    public getStatusSubject() {
        return this.status$;
    }
}
